import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table } from 'antd';
@inject('reportStore')
@observer
class SearchResult extends Component {
  state={
  }
  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const { reportStore } = this.props;
    reportStore.onChangePageNumAction(page, pageSize);
    reportStore.onChangeSelectedRowKeys([],[])
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { reportStore } = this.props;
    reportStore.onChangeSelectedRowKeys(selectedRowKeys,selectedRows)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { reportStore } = this.props
    const { pageNo, pageSize, itemCount, eBillingList,selectedRowKeys } = reportStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
      return (
        <>
          <Table className='searchResult' dataSource={toJS(eBillingList)} rowClassName={this.getRowClassName} rowSelection={rowSelection} pagination={pagination} rowKey="id" scroll={{ x: 'max-content',scrollToFirstRowOnChange:true}} bordered >
            <Table.Column title='Partner Number' dataIndex="dataReceiver" key="dataReceiver"  />
            <Table.Column title='Data Generation Time' dataIndex="dataGenerationTime" key="dataGenerationTime"  />
            <Table.Column title='Customer PO' dataIndex="customerPurchaseCode" key="customerPurchaseCode"  />
            <Table.Column title='Customer PO Date' dataIndex="customerPurchaseDate" key="customerPurchaseDate"  />
            <Table.Column title='Original RDD' dataIndex="rdeliveryDate" key="rdeliveryDate"  />
            <Table.Column title='Sold To' dataIndex="buyerCode" key="buyerCode"  />
            <Table.Column title='Sold To Name' dataIndex="buyerName" key="buyerName"  />
            <Table.Column title='Ship To' dataIndex="shipToCode" key="shipToCode"  />n
            <Table.Column title='Ship To Name' dataIndex="shipToName" key="shipToName"  />
            <Table.Column title='Billing No' dataIndex="billingNo" key="billingNo"  />
            <Table.Column title='Billing Date' dataIndex="docDate" key="docDate"  />
            <Table.Column title='PG SKU' dataIndex="vendorProductCode" key="vendorProductCode"  />
            <Table.Column title='Customer SKU' dataIndex="customerSku" key="customerSku"  />
            <Table.Column title='GTIN' dataIndex="gtin" key="gtin"  />
            <Table.Column title='Material Name' dataIndex="materialName" key="materialName"  />
            <Table.Column title='Quantity' dataIndex="number" key="number"  />
            <Table.Column title='Unit' dataIndex="unit" key="unit"  />
            <Table.Column title='Customer Quantity' dataIndex="buyerNumberConv" key="buyerNumberConv"  />
            <Table.Column title='Amount SLOG' dataIndex="amountSlog" key="amountSlog"  />
            <Table.Column title='Price SLOG' dataIndex="priceSlog" key="priceSlog"  />
            <Table.Column title='Amount' dataIndex="amountWithoutTax" key="amountWithoutTax"  />
            <Table.Column title='Tax' dataIndex="amountTax" key="amountTax"  />
            <Table.Column title='Net Price' dataIndex="priceWithoutTax" key="priceWithoutTax"  />
            <Table.Column title='Price' dataIndex="priceWithTax" key="priceWithTax"  />
            <Table.Column title='Message ID' dataIndex="requestId" key="requestId"  />
          </Table>
        </>
      );
  }
}

export default SearchResult;
